import getters from './getters';
import mutations from './mutations';

const state = {
  ManagementFee: '',
  OtherFees: '',
  Service12b1Fee: '',
  UnderlyingFundsFee: ''
};

export default {
  state,
  getters,
  mutations
};
